import React from "react";

const CONSTITUTION_URL = "https://customer-assets.emergentagent.com/job_njas-justice/artifacts/5gpneqf8_NOT%20JUST%20A%20STATISTIC%20LTD%20Company%20Constitution%2005072026.pdf";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="fade-in">
      <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-16 lg:pt-24 pb-12">
        <div className="njas-eyebrow">Legal</div>
        <h1 className="njas-display text-6xl sm:text-8xl text-njas-navy mt-4 leading-[0.88]">
          PRIVACY&nbsp;POLICY.
        </h1>
        <p className="mt-6 max-w-3xl text-njas-muted">
          This policy explains how Not Just A Statistic Ltd handles personal and financial information.
          It is written to comply with the Australian Privacy Principles (APPs) under the Privacy Act
          1988 (Cth) and the Payment Card Industry Data Security Standards (PCI-DSS).
        </p>
        <p className="mt-4 text-xs text-njas-muted">Last updated: {new Date().toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}</p>
      </section>

      <section className="max-w-[900px] mx-auto px-4 sm:px-6 lg:px-10 pb-24 space-y-14">
        <Clause n="01" title="Collection of Personal and Financial Information" testid="privacy-1">
          <p>
            We collect personal information necessary to process your donations, issue official tax
            receipts, and comply with Australian taxation laws. This includes your full name, email
            address, physical address (for tax receipting), and billing information.
          </p>
          <p>
            We also collect information you provide via our referral, volunteer, membership and contact
            forms to enable us to deliver services and respond to enquiries.
          </p>
        </Clause>

        <Clause n="02" title="Credit Card Data Security &amp; Payment Processing" testid="privacy-2">
          <p>
            All online credit card transactions are processed securely through our third party payment
            gateway provider (Stripe, once activated). Your credit card details are encrypted using
            Secure Sockets Layer (SSL) technology and sent directly to the processor.
          </p>
          <p>
            Not Just A Statistic Ltd does not capture, store, or view your full credit card number or
            CVV/CVC security code on our internal servers or systems. All processing complies strictly
            with the Payment Card Industry Data Security Standard (PCI-DSS).
          </p>
        </Clause>

        <Clause n="03" title="Purpose of Use and Disclosure" testid="privacy-3">
          <p>
            Financial data is used solely to process your authorised transaction, manage recurring
            donation schedules (if selected), and handle refund requests.
          </p>
          <p>
            Your financial information will never be shared, sold, rented, or disclosed to third
            parties for marketing purposes. It will only be disclosed if required by law or to verify
            transactions with our financial institution.
          </p>
          <p>
            Personal information collected through client, volunteer and membership channels is held
            in strict confidence and handled in accordance with our internal Privacy &amp;
            Confidentiality Policy and applicable safeguarding legislation.
          </p>
        </Clause>

        <Clause n="04" title="Cross-Border / Overseas Data Transfer" testid="privacy-4">
          <p>
            Some of our third party service providers and payment processors utilise cloud based
            infrastructure located outside of Australia (such as the United States). By submitting
            your donation or personal information, you consent to the secure transfer and storage of
            your information on these secure international servers in compliance with global data
            protection standards.
          </p>
        </Clause>

        <Clause n="05" title="Data Retention and Destruction" testid="privacy-5">
          <p>
            Under Australian taxation law, records of your donation and tax receipt must be retained
            by us for a minimum of seven (7) years.
          </p>
          <p>
            All tokenised or temporary credit card data used for a live transaction is cleared or
            securely deleted immediately upon successful completion of the payment.
          </p>
          <p>
            Client case records and referral information are retained in accordance with our internal
            Case Notes Policy and any applicable legal requirements, and are securely destroyed at
            the end of the required retention period.
          </p>
        </Clause>

        <Clause n="06" title="Your Rights &amp; How to Contact Us" testid="privacy-6">
          <p>
            You have the right to request access to the personal information we hold about you, to
            request correction of any inaccuracies, and to lodge a complaint about how we handle your
            information.
          </p>
          <p>
            To exercise these rights, or if you have any questions about this policy, please contact
            us at <a className="njas-link text-njas-navy" href="mailto:info@njas.org.au">info@njas.org.au</a>.
            If you are not satisfied with our response, you may lodge a complaint with the Office of
            the Australian Information Commissioner (OAIC) at <a className="njas-link text-njas-navy" href="https://www.oaic.gov.au" target="_blank" rel="noreferrer">oaic.gov.au</a>.
          </p>
        </Clause>

        <div className="mt-16 njas-h-rule" />
        <p className="text-sm text-njas-muted">
          This policy should be read alongside our{" "}
          <a href={CONSTITUTION_URL} target="_blank" rel="noreferrer" className="njas-link text-njas-navy">Company Constitution</a>{" "}
          and any additional internal privacy and confidentiality policies maintained by the Board.
        </p>
      </section>
    </div>
  );
}

function Clause({ n, title, children, testid }) {
  return (
    <article className="grid grid-cols-12 gap-6" data-testid={testid}>
      <div className="col-span-2 njas-display text-4xl text-njas-sage">{n}</div>
      <div className="col-span-10">
        <h2 className="njas-display text-3xl sm:text-4xl text-njas-navy leading-tight" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="mt-4 space-y-4 text-njas-text leading-relaxed">{children}</div>
      </div>
    </article>
  );
}
